module.exports = __webpack_public_path__ + "static/media/track&trace.8ebec12d.svg";